import React from "react";
import Reveal from "../site/Reveal";
import { SectionLabel } from "../site/Bits";
import { WHY_LYKIT, COMPANY } from "../../lib/content";

export default function WhyLykit() {
  return (
    <section className="lk-section" data-testid="why-lykit-section">
      <div className="lk-container-wide">
        <div className="grid gap-y-10 lg:grid-cols-12 lg:gap-x-14">
          <div className="lg:col-span-5">
            <Reveal>
              <SectionLabel>Why LYKIT</SectionLabel>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="display-lg mt-7 max-w-[16ch]">
                WHERE CREATIVITY MEETS <span style={{ color: "#352A59" }}>EXECUTION.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-8 max-w-[34ch] text-[14px] leading-[1.6] body-muted">
                {COMPANY.secondaryTagline}
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="grid sm:grid-cols-2">
              {WHY_LYKIT.map((point, i) => (
                <Reveal
                  key={point.num}
                  delay={0.06 * i}
                  data-testid="why-lykit-point"
                  className="relative py-8 sm:px-8 sm:first:pl-0"
                  style={{
                    borderTop: "1px solid rgba(23,21,34,0.10)",
                  }}
                >
                  <span
                    aria-hidden="true"
                    className="outline-number block text-[34px]"
                  >
                    {point.num}
                  </span>
                  <h3 className="mt-4 font-display text-[clamp(17px,1.4vw,21px)] font-extrabold tracking-[-0.02em]">
                    {point.title}
                  </h3>
                  <p className="mt-3 max-w-[34ch] text-[14px] leading-[1.62] body-muted">{point.text}</p>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
